module.exports = __webpack_public_path__ + "fonts/43eec59ca7b80adb8159652a018947c0.svg";